<template>
    <div style="padding-bottom:50px">
        <div @click="redirectPreviousUrl"
            style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
            <p>
                <a-icon type="double-left" />
            </p>
            <p>Go Back </p>

        </div>
        <div style="display:flex;justify-content: flex-end;">
            <a-button @click="downloadReceipt" style="border-raduis:5px; background: #418a49; color:#fff;"> Download
                <a-icon type="download" /> </a-button>
        </div>
        <div id="printMe" style="margin-top:50px;background:#fff; padding:30px;">
            <div class="container">
                <!-- Content here -->
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <!-- <div style="background-color:#ccc;;width: 70px; height: 37px;margin-top:5px;"></div> -->
                            </div>
                            <div class="col">
                                <!-- <span style="font-size:20px; font-weight:bolder">{{supplierDetails.name}}</span>
                                <span style="font-size:13px;display:block">{{supplierDetails.address}}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div style="float:right">
                            <span style="font-size:20px; font-weight:bolder">PURCHASE ORDER</span>
                            <span style="font-size:16px;display:block">DATE: {{ currentDate }}</span>
                            <!-- <span style="font-size:16px;display:block">#34566</span> -->
                        </div>
                    </div>
                </div>
                <div class="row justify-content-md-center mt-3">
                    <div class="col">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <div class="row">
                                <div class="col-4" style="font-weight:bolder;font-size:18px;">
                                    Supplier:
                                </div>
                                <div class="col-8">
                                    <span style="font-weight:bolder;font-size:16px;">
                                        {{ supplierName }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierAddress }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierCity }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierCountry }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <div class="row">
                                <div class="col-4" style="font-weight:bolder;font-size:18px;">
                                    Ship To:
                                </div>
                                <div class="col-8">
                                    <span style="font-weight:bolder;font-size:16px;">
                                        {{ destionation }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipAddress }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipCity }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipCountry }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top:30px;display: flex; justify-content: space-between">
                    <div class="col">
                        <div style="font-weight:bolder">Shipping Method</div>
                        <div style="padding-left: 38px;padding-right: 38px;">{{ shippingMethod }}</div>
                    </div>

                    <div class="col" style="text-align: end;" :span="12">
                        <div style="font-weight:bolder">Delivery Date</div>
                        <div style="">
                            {{ deliveryDate }}
                        </div>
                    </div>
                </div>
                <div style="margin-top:30px">
                    <table class="table table-striped table-hover table-bordered">

                        <thead>
                            <tr>
                                <th scope="col">Product Name</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">UnitPrice</th>
                                <th scope="col">Line Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in tableData" :key="product.id">
                                <td>{{ product.name }}</td>
                                <td>{{ product.quantity }}</td>
                                <td>{{ product.unitPrice }}</td>
                                <td>{{ product.lineTotal }}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div style="margin-top:40px">
                    <div class="row">
                        <div class="col">
                            <p style="font-weight:bolder">Shipping Terms:</p>
                            <p>{{ shippinTerm }}</p>
                        </div>
                        <div class="col">
                            <div class="row" style="display:flex;justify-content: flex-end;">
                                <div class="col" style="font-weight:bolder;font-size: 19px;" :span="8">Sub Total: </div>
                                <div class="col" :span="12" style="font-size: 19px;">Ksh {{ displayTotalAmount }}</div>
                            </div>
                            <div class="row" style="display:flex;justify-content: flex-end;">
                                <div class="col" style="font-weight:bolder;font-size: 19px;" :span="8">Discount: </div>
                                <div class="col" style="display:flex; height:20px;font-size: 19px;" :span="12">
                                    - {{ discount }}
                                </div>
                            </div>
                            <div class="col" style="display:flex;justify-content: flex-end;padding-top:30px">
                                <div class="col-8" style="font-weight:bolder;font-size: 25px;">Grand Total: </div>
                                <div class="col-6" style="font-weight:bolder;font-size: 25px;">Ksh {{ displayGrandTotal }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a-modal class="modalStyle" :visible="addProductVisible" :footer="null" @cancel="handleAddProductCancel">
                <a-spin :spinning="loading">
                    <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Download
                    </h4>
                    <div>
                        <h5>Are you sure you want to download?</h5>
                        <div style="display:flex;justify-content:center;margin-top:20px">
                            <a-button @click="submitReceipt"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Download
                            </a-button>
                        </div>

                    </div>
                </a-spin>
            </a-modal>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

const columns = [
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name",
        // scopedSlots: { customRender: 'name' },
        width: 200,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     // scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 200,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity",
        // scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Selling Price',
        dataIndex: 'unitPrice',
        key: "unitPrice",
        // scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    {
        title: 'Line Total',
        dataIndex: 'lineTotal',
        key: "lineTotal"
        // width: 200,
    },

]

export default {
    name: "PurchasedReceipt",
    data() {
        return {
            columns,
            tableData: [],
            tableLoading: false,
            discount: 0,
            deliveryDate: "",
            loading: false,
            supplierName: "",
            addProductVisible: false,
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            shipAddress: "",
            shipCity: "",
            shipCountry: "",
            shippinTerm: "",
            originalData: [],
            supplierDetails: {}
        };
    },
    computed: {
        ...mapGetters(['getPreViewInfo', 'IsAgentProfileAvailable']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.quantity) {
                    return parseFloat(item.unitPrice) * item.quantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        },

        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount).toFixed(2)
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'generatePurcharseOrder']),
        redirectPreviousUrl() {
            this.$router.back()
        },
        handleAddProductCancel() {
            this.addProductVisible = false
        },
        downloadReceipt() {

            this.addProductVisible = true
            // this.$htmlToPaper('printMe');
        },
        submitReceipt() {
            this.loading = true

            let jsonObject = JSON.parse(this.getPreViewInfo)
            // console.log("getPreViewInfo | ", jsonObject)
            let productLine = [];
            this.tableData.map(response => {
                productLine.push({
                    productId: response.id,
                    quantity: response.quantity,
                    price: response.unitPrice
                })
            })
            // console.log("productLine | ", productLine)
            delete jsonObject['tableData']

            let request_data = {
                userId: this.IsAgentProfileAvailable.id,
                supplierId: jsonObject.supplierDetails.id,
                supplierAddress: jsonObject.supplierDetails.address,
                sellerAddress: JSON.stringify(jsonObject),
                productLines: productLine
            }
            // console.log("request_data | ", request_data)
            this.generatePurcharseOrder(request_data).then(response => {
                this.loading = false
                if (response.status === 200) {
                    this.$htmlToPaper('printMe');
                    this.$router.push('/purchase-order-history').catch(() => { });
                    this.addProductVisible = false;
                } else {
                    // console.log("Error | ", response)
                }
            }, error => {
                console.log("Error | ", error)
            })
        },
    },
    created() {
        if (this.getPreViewInfo) {
            // console.log("getPreViewInfo | ", this.getPreViewInfo)
            let result = JSON.parse(this.getPreViewInfo)

            this.discount = result.discount ? result.discount : 0
            this.deliveryDate = result.deliveryDate ? result.deliveryDate : 'N/A'
            this.supplierName = result.supplierName ? result.supplierName : 'N/A'
            this.supplierAddress = result.supplierAddress ? result.supplierAddress : 'N/A'
            this.supplierCity = result.supplierCity ? result.supplierCity : 'N/A'
            this.supplierCountry = result.supplierCountry ? result.supplierCountry : 'N/A'
            this.destionation = result.destionation ? result.destionation : 'N/A'
            this.shipAddress = result.shipAddress ? result.shipAddress : 'N/A'
            this.shipCity = result.shipCity ? result.shipCity : 'N/A'
            this.shipCountry = result.shipCountry ? result.shipCountry : 'N/A'
            this.shippingMethod = result.shippingMethod ? result.shippingMethod : 'N/A'
            this.shippinTerm = result.shippinTerm ? result.shippinTerm : 'N/A'
            this.tableData = result.tableData,
                this.originalData = result.originalData
            this.supplierDetails = result.supplierDetails
        }
    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

a {
    text-decoration: none;
}

@media print {
    @page {
        size: landscape
    }
}
</style>